import Vue from 'vue'
import { toDate, uppercase, toPriceCurrency, toPercent } from '@/utils/filters'
export default function (app) {
  Vue.filter('uppercase', uppercase)
  Vue.filter('toPriceCurrency', toPriceCurrency)
  Vue.filter('toDate', toDate)
  Vue.filter('toPercent', toPercent)
  Vue.filter('dynamicFilter', (value, name, ...args) => {
    let filter = Vue.filter(name)
    if (filter) {
      return filter(value, ...args)
    } else {
      return value
    }
  })
}
